<template functional>
  <transition :name="props.transitionName" mode="out-in">
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'Swipe',
};
</script>

<style lang="scss">
.swipe-left-enter-active, .swipe-right-enter-active {
  transition: all .1s ease;
}
.swipe-left-leave-active, .swipe-right-leave-active {
  transition: all .1s ease;
}
.swipe-right-enter {
  transform: translateX(-100%);
  opacity: 0;
}

.swipe-right-leave-to  {
  transform: translateX(100%);
  opacity: 0;
}

.swipe-left-enter {
  transform: translateX(100%);
  opacity: 0;
}

.swipe-left-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
</style>
